import { createFileRoute } from '@tanstack/react-router';
import EmployeeProfileView from '@features/employees/EmployeeProfileView';

export const Route = createFileRoute('/w/employees/profile/$employeeId')({
  staticData: { breadcrumb: 'Employee Profile', breadcrumbKey: 'K_BREADCRUMB_EMPLOYEE_PROFILE' },
  validateSearch: (search: Record<string, unknown>): { edit?: boolean } => {
    if (search.edit === true || search.edit === 'true') return { edit: true };
    return {};
  },
  component: AdminEmployeeProfilePage,
});

function AdminEmployeeProfilePage() {
  const { employeeId } = Route.useParams();
  const { edit } = Route.useSearch();

  return (
    <EmployeeProfileView employeeId={employeeId} showTenantInfo initialEdit={edit ?? false} />
  );
}
